import http from './http'
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = "/apis"
// let url={
//     buyer:'https://buyer-api.planttech.cn/buyer'
// }

//表单
export function queryForm(params){
    return http.post(`${resquest}/user/form/public/query/data`,params)
}

//通知动态
export function dynamics(params){
    return http.get(`${resquest}/wx/getCmNews`,params)
}

//通知动态详情
export function dynamicsDetails(id){
    return http.get(`${resquest}/wx/getCmNewsById/${id}`)
}

//注册
export function register(params){
    return http.post(`${resquest}/register`,params)
}

//登录
export function login(params){
    return http.post(`${resquest}/largescreenLogin`,params)
}

//登出
export function logout(){
    return http.post(`${resquest}/logout`)
}


//获取图片验证码
export function getCaptcha(){
    return http.get(`${resquest}/getCaptcha`)
}

//获取信息
export function getInfo(){
    return http.get(`${resquest}/getInfo`)
}




